<div
  (click)="navigateToProfile()"
  [ngClass]="{ 'cursor-p': isCreator || userProfile?.refer_id }"
  class="profileImage-user"
>
  <div>
    <app-user-image></app-user-image>
  </div>
  <div
    class="profileImage-content"
    [ngClass]="{
      'profile-content-m': userProfile?.delegate_user?.type?.length
    }"
  >
    <div
      *ngIf="((userProfile?.first_name || '') + ' ' + (userProfile?.last_name || '')).trim() as fullName"
      class="profileImage-title"
    >
      <!-- <span *ngIf="isCreator">{{ userProfile?.displayed_name }}</span> -->
      <ng-container
        *ngFor="let part of (fullName?.split(' ') || []); let isLast = last"
      >
        <span [ngClass]="{ 'last-word': isLast }">
          {{ part }}<ng-container *ngIf="!isLast">&nbsp;</ng-container>
          <ng-container *ngIf="isLast">
            <app-tick-icon [creatorData]="userProfile"></app-tick-icon>
          </ng-container>
        </span>
      </ng-container>
    </div>
    <div
      *ngIf="userProfile?.delegate_user?.type?.length"
      class="delegate-type-side-bar"
    >
      <div class="red-dot"></div>
      <div class="status">{{ delegateContent }} Delegate Mode</div>
    </div>
  </div>
</div>
